module.exports = __webpack_public_path__ + "img/case-logo-42.e09529c2.png";